import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=c42b5a58&"
import script from "./Resultados.vue?vue&type=script&lang=js&"
export * from "./Resultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports